<div class="login">
    <div class="login-area">
        <div class="login-heading">
					<img [src]="'assets/img/' + logo" style="max-width: 100%" />
        </div>
        <div class="login-text">
            <p>To contact us for support or to have your account permanently removed, please email us at <a href="mailto:support@vergeaero.com">support&#64;vergeaero.com</a></p>
        </div>
    </div>
</div>